(ns app.domain.group.ecm-integration-model
  (:require [potpuri.core :as p]))

(defn system-name-tr-args [{:group/keys [ecm-integration-config]}]
  (when-let [service (:integration-config/service ecm-integration-config)]
    [(keyword "integration-config.service.short" (name service))
     service
     "ECM"]))

(defn system-name [tr group]
  (when-let [args (system-name-tr-args group)]
    (tr args)))

(defmulti ^{:arglists '([workspace])} folder-link
  (fn [workspace]
    (-> workspace
        :domain/authority-group
        :group/ecm-integration-config
        :integration-config/service)))

(defmethod folder-link :default [_workspace]
  nil)

(defmethod folder-link :integration-config.service/laserfiche-cloud [workspace]
  (p/if-all-let [url (-> workspace
                         :domain/authority-group
                         :group/ecm-integration-config
                         :integration-config/base-url)
                 id  (:entity/ecm-integration-id workspace)]
    (let [[_ tld repo] (re-find #"https://api.laserfiche.(\w+)/repository/v2/Repositories/([\w\d-]+)" url)]
      (when (and tld repo)
        (str "https://app.laserfiche." tld "/laserfiche/browse.aspx?repo=" repo "#?id=" id)))))
